const _excluded = ["className", "children", "headTitle"],
  _excluded2 = ["children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import styles from "./CommonComponents.module.scss";
import { Typography } from 'seagull';
export function AgreementViewCard(_ref) {
  let {
      className,
      children,
      headTitle
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("section", _extends({
    className: cn(styles.card, className)
  }, rest), headTitle && /*#__PURE__*/React.createElement(SectionTitle, {
    className: styles.sectionTitle
  }, headTitle), children);
}
export function SectionTitle(_ref2) {
  let {
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Typography, _extends({}, props, {
    variant: "h5"
  }), children);
}
export function Logo(_ref3) {
  let {
    logoUrl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.logoContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.circle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logoImageBorder
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.logoImageContainer,
    style: {
      backgroundImage: "url(".concat(logoUrl, ")")
    }
  })));
}
export function TopStripe(_ref4) {
  let {
    backgroundColor
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.topStripe,
    style: {
      backgroundColor
    }
  });
}
export function SpecificTerm(props) {
  const {
    field,
    value,
    testid,
    changes
  } = props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.specificTerm
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "bold"
  }, field), /*#__PURE__*/React.createElement(Typography, {
    ellipsis: true,
    "data-testid": testid
  }, value)), changes && /*#__PURE__*/React.createElement("div", {
    className: styles.changes
  }, changes));
}